import { useEffect, useState } from 'react';
import BigNumber from 'bignumber.js';
import saleAbi from '../config/abis/sale.json';
import erc20Abi from '../config/abis/erc20.json';
import nftPlayerAbi from '../config/abis/nft-player.json';
import { getAddress, multiCall, loadContract } from '../services/utils';

import useAppStore from '../store/use-app-store';

const saleAddress = getAddress('sale');
const nftAdminAddress = getAddress('nftAdmin');

const useSaleContract = () => {
  const walletConnected = useAppStore((state) => state.walletState.walletConnected);
  const [saleState, setSaleState] = useState({
    loading: true,
    packs: [],
    discounts: [],
    nftRemaining: 0,
    startTime: 0,
    started: false,
  });
  const [reload, setReload] = useState(0);

  useEffect(() => {
    const fetchSale = async () => {
      const nftPlayerContract = loadContract('nftPlayer', nftPlayerAbi);
      const nftRemaining = await nftPlayerContract.balanceOf(nftAdminAddress);

      const usdContract = loadContract('usdc', erc20Abi);
      const decimals = await usdContract.decimals();

      const saleContract = loadContract('sale', saleAbi);
      const packsLength = await saleContract.packsLength();
      const discountsLength = await saleContract.discountsLength();
      const startTime = await saleContract.startTime();

      const saleCalls = new Array(packsLength.toNumber()).fill('pack').map((el, i) => ({
        address: saleAddress,
        name: 'packs',
        params: [i],
      }));

      for (let i = 0; new BigNumber(discountsLength._hex).gt(i); i++) {
        saleCalls.push({
          address: saleAddress,
          name: 'discounts',
          params: [i],
        });
      }

      const saleResults = await multiCall(saleAbi, saleCalls);
      const packs = new Array(packsLength.toNumber()).fill('pack').map((el, i) => ({
        id: i,
        maxSellQty: new BigNumber(saleResults[i].maxSellQty._hex).toJSON(),
        price: new BigNumber(saleResults[i].price._hex).div(new BigNumber(10).pow(decimals)).toJSON(),
        qty: new BigNumber(saleResults[i].qty._hex).toJSON(),
      }));
      const discountsOffset = packsLength.toNumber();
      const discounts = new Array(discountsLength.toNumber()).fill('discount').map((el, i) => ({
        id: i,
        per: new BigNumber(saleResults[discountsOffset + i].per._hex).toJSON(),
        qty: new BigNumber(saleResults[discountsOffset + i].qty._hex).toJSON(),
      }));

      setSaleState({
        loading: false,
        packs,
        discounts,
        nftRemaining: new BigNumber(nftRemaining._hex).toJSON(),
        startTime: new BigNumber(startTime._hex).toJSON(),
        started: new BigNumber(startTime._hex).times(1000).lt(Date.now()),
      });
    }

    fetchSale();
  }, [walletConnected, setSaleState, reload]);

  return {
    walletConnected,
    saleState,
    setReload
  }
}

export default useSaleContract;
